import { typeGuard } from '@/lib/utils';
import type { OrganizationUser } from '@pigello/pigello-matrix';
import { ORGANIZATION_USER_DETAIL_ACCESS } from './constants';

/**
 * The name-bearing fields of an organization user. Structural so the helper
 * accepts both the matrix `OrganizationUser` and the construct
 * `AccountsOrganizationUser`.
 */
type NameableOrganizationUser = {
  detailAccess?: number | null;
  corporateName?: string | null;
  communicationName?: string | null;
};

/**
 * Returns the display name for an organization user.
 * External users (detailAccess === 2) display corporateName if present, otherwise fall back to communicationName.
 * Non-external users display communicationName if present, otherwise return '-'.
 * Both branches may fall back to '-' when no name is available.
 */
export function getOrganizationUserName(
  data: NameableOrganizationUser | undefined | null
): string {
  if (!data) {
    return '-';
  }
  // If the user is external we show their corporate name
  if (data.detailAccess === ORGANIZATION_USER_DETAIL_ACCESS.EXTERNAL) {
    return data.corporateName || data.communicationName || '-';
  }
  return data.communicationName || '-';
}

export function isOrganizationUser(data: unknown): data is OrganizationUser {
  return typeGuard<OrganizationUser>(data, 'detailAccess');
}
